import React, {useMemo} from "react";
import {Button, Col, Row} from "antd";
import {formatDateShort} from "@lib/format";
import DynamicBlock from "@components/block/Dynamic";
import {FlagCta} from "@components/call-to-action";

const HomePageCPContent = ({windowDimensions, cpContent}) => {

    const taxonColspan = useMemo(() => {
        if(windowDimensions.under(1200)) return 12;
        return 6;
    }, [windowDimensions]);

    const postColspan = useMemo(() => {
        if(windowDimensions.under(1000)) return 24;
        return 12;
    }, [windowDimensions]);

    const showVerticalPostLayout = useMemo(() => {
        return !!windowDimensions.under(600);

    }, [windowDimensions]);

    const posts = useMemo(() => {
        return cpContent?.posts || [];
    }, [cpContent]);

    return (
        <div className="homepage-cp-content">
            <h2 >Latest Articles, News, Reports & More</h2>

            {cpContent && cpContent.articles && (
                <div className={"ant-layout covr-articles"}>
                    <DynamicBlock blocks={[cpContent.articles]} />
                </div>
            )}


            <div className="border-bottom-darkgrey mar-top-20 mar-bot-20"/>

            {cpContent && cpContent.videos && (
                <DynamicBlock blocks={[cpContent.videos ]} className={"ant-layout covr-youtube-search"} />
            )}

            <Row justify="center">
                <Button className="homepage-section-big-button" href="/cp-content">More CP Content</Button>
            </Row>

        </div>
    );
};

export default HomePageCPContent;